// close navbar collapse on click
var navbarLinks = document.querySelectorAll('#navbarCollapse .nav-link');
var navbarToggler = document.querySelector('.navbar-toggler');

navbarLinks.forEach(function setUpNavbarLinkCollapseEvents(navbarLink) {
    navbarLink.addEventListener('click', function collapseNavbarOnClick() {
        navbarToggler.click();
    });
});
